module.exports = __webpack_public_path__ + "static/media/acklands-grainger.73052e20.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/where-to-buy/acklands-grainger.jpg
// module id = 1309
// module chunks = 0